import { render, staticRenderFns } from "./AdminProgramOverview.vue?vue&type=template&id=7640fb65&"
import script from "./AdminProgramOverview.vue?vue&type=script&lang=js&"
export * from "./AdminProgramOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports